import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { FloatingLabel, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import LoadingModal from "../../components/LoadingModal.js";
import AlertModal from "../../../components/AlertModal.js";
import { TalukServices } from "../../../services/Taluk.js";
import { AuthService } from "../../../services/AuthService.js";
import styles from "../../../styles/Modal.module.css";

function EditTalukModal({ show, onHide, taluk }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [taluks, setTaluks] = useState({ id: undefined, taluk: "", totalAshaCount: "" });
  const [error, setError] = useState({ taluk: "" });

  const [alertData, setAlertData] = useState({
    show: false,
    title: "",
    message: "",
    variant: "success",
  });

  const validation = () => {
    let tempError = { taluk: "" };
    let valid = true;
    if (!taluks.taluk.trim()) {
      tempError.taluk = "Taluk is required";
      valid = false;
    }
    setError(tempError);
    return valid;
  };

  const updateTaluk = async () => {
    if (!validation()) return;

    setLoading(true);
    try {
      const res = await TalukServices.updateTaluk({ ...taluks });
      if (res.status === 200) {
        onHide();
        setAlertData({
          show: true,
          title: "Success",
          message: res.message || "Taluk updated successfully!",
          variant: "success",
        });
      } else {
        throw new Error(res.message || "Error while updating Taluk");
      }
    } catch (error) {
      setAlertData({
        show: true,
        title: "Error",
        message: error.message || "Failed to update Taluk. Please try again.",
        variant: "danger",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleAlertClose = () => {
    setAlertData((prev) => ({ ...prev, show: false }));
    if (alertData.variant === "success") {
      navigate("/taluk");
    }
  };

  useEffect(() => {
    if (show && taluk) {
      setTaluks({ id: taluk.id, taluk: taluk.taluk, totalAshaCount: taluk.totalAshaCount });
    }
  }, [show, taluk]);

  return (
    <>
      <Modal show={show} onHide={onHide} size="md" centered className={styles.modalShow}>
        <Modal.Header closeButton className={styles.modalHeader}>
          <Modal.Title className={styles.modalTitle}>
            <i className="fas fa-edit me-2"></i>
            Edit Taluk
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles.modalBody}>
          <div className={styles.formGroup}>
            <FloatingLabel
              controlId="editTaluk"
              label={
                <>
                  Taluk <span className="text-danger">*</span>
                </>
              }
            >
              <Form.Control
                type="text"
                placeholder="Enter Taluk"
                value={taluks.taluk}
                onChange={(e) => setTaluks({ ...taluks, taluk: e.target.value })}
                isInvalid={!!error.taluk}
              />
              <Form.Control.Feedback type="invalid">
                {error.taluk}
              </Form.Control.Feedback>
            </FloatingLabel>
          </div>

          <div className={styles.formGroup}>
            <FloatingLabel
              controlId="editAshaCount"
              label="Total Asha Count"
            >
              <Form.Control
                type="number"
                placeholder="Enter Total Asha Count"
                value={taluks.totalAshaCount}
                onChange={(e) => setTaluks({ ...taluks, totalAshaCount: e.target.value })}
              />
            </FloatingLabel>
          </div>
        </Modal.Body>
        <Modal.Footer className={styles.modalFooter}>
          {AuthService.canUpdate() && (
            <Button
              variant="success"
              onClick={updateTaluk}
              className={styles.primaryButton}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Updating...
                </>
              ) : (
                <>
                  <i className="fas fa-save me-1"></i>
                  Update Taluk
                </>
              )}
            </Button>
          )}
          <Button
            variant="danger"
            onClick={onHide}
            className={styles.secondaryButton}
          >
            <i className="fas fa-times me-1"></i>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <LoadingModal show={loading} />

      <AlertModal
        show={alertData.show}
        onHide={handleAlertClose}
        title={alertData.title}
        message={alertData.message}
        variant={alertData.variant}
      />
    </>
  );
}

function EditTaluk(props) {
  const [modalShow, setModalShow] = useState(false);

  return (
    <>
      <FontAwesomeIcon
        icon={faEdit}
        style={{ color: '#05275a' }}
        size="lg"
        onClick={() => setModalShow(true)}
      />
      <EditTalukModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        taluk={props.taluk}
      />
    </>
  );
}

export default EditTaluk;
